<div class="root">
    @if (users$ | async) {
        <ul>
            @for (user of users; track user.id; let i = $index) {
                <li (click)="select.emit(user)" [class.active]="i === index">
                    {{ user.name }}
                </li>
            }
        </ul>
    }
</div>
